import { Outlet, Route, Routes } from "react-router-dom";
import TaskPage from "../../Pages/TaskPage";
import SideMenu from "./SideMenu";

const Content=()=>{
    return (
        <>
<div className="container-fluid">
    <div className="row">
        {/* side menu */}
        <SideMenu/>
        {/* content to be Displayed here */}
            <Outlet/> 
    </div>
</div>
        </> 
    )
}
export default Content;